import React from "react";
import MediaContentUploadComponent from "../../media/content/MediaContentUploadComponent";
import PageFormError from "../errors/PageFormError";
import MediaHelper from "../../../helpers/MediaHelper";
import StandardTextFormEditorComponent from "../../basics/form/StandardTextFormEditorComponent";
import FormattedMessageString from "../../basics/FormattedMessageString";
import PageCustomSettingsFormComponent from "../PageCustomSettingsFormComponent";
import PageModuleSettingsFormComponent from "../PageModuleSettingsFormComponent";

class PageTextFormComponent {
    static addFields(form, props) {
        let fields = [{
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Pages.Form.name",
                    type: "text",
                    name: "name",
                    customFeedback: PageFormError,
                    formErrorName: "title"
                }
            ]
        },
        {
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Pages.Form.type",
                    type: "select",
                    name: "type",
                    options: props.types,
                    disabled: props.isEdit,
                    onChange: form.handleTypeChange
                }
            ]
        },
        {
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Pages.Form.modules",
                    type: "select",
                    name: props.selectedType && props.selectedType.indexOf('module') > -1 ? 'modules' : null,
                    options: props.modulesList,
                    message: "CMS.Pages.Form.modules.message",
                    multi: true,
                    sortable: true,
                    beforeOnChange: form.formatModulesValue,
                    onChange: form.handleModuleSelection,
                    customFeedback: PageFormError,
                    formErrorName: "modules"
                }
            ]
        }];

        props.selectedModulesData.forEach(record => {
            fields.push({
                type: "col",
                md: 12,
                fields: [{
                    title: record.module.title,
                    type: "select",
                    name: 'category_' + record.module.id,
                    placeholder: 'CMS.Page.Form.categories.message',
                    optional: true,
                    options: record.categories.map(category => { return { value: category.id, label: category.title } })
                }]
            });
        })

        if ((props.selectedModulesSettingsData || []).length > 0) {
            fields.push({
                type: "col",
                md: 12,
                fields: [],
                custom: PageModuleSettingsFormComponent,
                customProps: { modules: props.selectedModulesSettingsData, allModules: props.modules }
            });
        }

        fields.push({
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Pages.Form.parent",
                    type: "select",
                    name: "parent",
                    options: props.pages,
                    optional: true,
                    disabled: props.isEdit
                }
            ]
        });

        if (!props.isManager) {
            fields.push({
                type: "col",
                md: 12,
                fields: [],
                custom: PageCustomSettingsFormComponent
            });
        }

        return [{
            type: 'row',
            children: fields
        }];
    }

    static fields() {
        return [
            {
                type: "row",
                children: [
                    {
                        type: "col",
                        md: 12,
                        fields: [
                            {
                                title: "CMS.Page.Content.Form.title",
                                type: "text",
                                name: "value.title",
                                optional: true,
                                customFeedback: PageFormError
                            }
                        ]
                    },
                    {
                        type: "col",
                        md: 12,
                        fields: [],
                        custom: StandardTextFormEditorComponent
                    }
                ]
            }
        ]
    }

    static fields_image(isEdit = false, model = null, settings = {}) {
        return [
            {
                type: "row",
                children: [
                    (model && model.settings.has_special_blocks) ? {
                        type: "col",
                        md: 12,
                        fields: [
                            {
                                title: "CMS.Media.Content.block.form.type",
                                type: "select",
                                options: ['text', 'accordion'].map(item => { return { value: item, label: <FormattedMessageString id={'CMS.Page.Media.Content.block.title.' + item} /> } }),
                                name: "type",
                                optional: false,
                                fake: !isEdit,
                                beforeOnChange: settings.onBlockTypeChange
                            },
                        ]
                    } : {},
                    {
                        type: "col",
                        md: 12,
                        fields: [
                            {
                                title: "CMS.Page.Content.Form.title",
                                type: "text",
                                name: "title",
                                optional: settings.titleOptional,
                                fake: !isEdit
                            },
                        ]
                    },
                    {
                        type: "col",
                        md: 12,
                        fields: [],
                        custom: StandardTextFormEditorComponent,
                        fake: !isEdit
                    },
                    {
                        type: "col",
                        md: 12,
                        fields: [],
                        custom: MediaContentUploadComponent,
                        customProps: { type: 'page_text_image', model: model },
                        fake: isEdit
                    }
                ]
            }
        ]
    }

    static async fields_image_before_submit(element) {
        return new Promise(async (resolve, reject) => {
            let page_content = element.state.model
            let value = page_content.value;
            let value_content = value.content ? value.content : [];
            value_content = await Promise.all(value_content.map(async (item) => {
                if (item.image !== null && item.image !== undefined) {
                    item.image_src = await MediaHelper.uploadImage(item, 'image', 'page_text_image', 'page', element.props.id, null, item.title);
                    item.image = undefined;
                }
                return item;
            }))

            page_content.value.content = value_content;

            element.setState({ model: page_content }, () => resolve(true))
        })
    }
}

export default PageTextFormComponent;
